import React from 'react';
import AlertDialogSlide from '../../../components/TransitionModal/TransitionModalNoButton.jsx';
import Loading from '../../../components/Loading/Loading.jsx';
import getFileData, { fetchPublicDataFile } from '../../../APICall/Api.jsx';

const normalizeImageUrl = (url) => {
  const clean = (url || '').trim();
  if (!clean) return '';
  if (/^https?:\/\//i.test(clean) || clean.indexOf('//') === 0) {
    return encodeURI(clean);
  }
  return encodeURI(`https://buildgreenalbania.org/${clean.replace(/^\/+/, '')}`);
};
const getImageUrl = (item) => {
  if (!item) return '';
  if (item.foto) return item.foto;
  return '';
};

class SectionProjects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      visibleCount: 6,
      url: getFileData,
    };
  }

  callAPI = (lang) => {
    fetchPublicDataFile(`news${lang.capitalize()}.json`)
      .then(
        (result) => this.setState({ isLoaded: true, items: result.news || [], visibleCount: 6 }),
        (error)  => this.setState({ isLoaded: true, error }),
      );
  };

  componentDidMount()              { this.callAPI(this.props.lang); }
  componentWillReceiveProps(next)  {
    if (next.lang !== this.props.lang) {
      this.setState({ isLoaded: false });
      this.callAPI(next.lang);
    }
  }

  render() {
    if (this.state.error)    return <div>Error loading news.</div>;
    if (!this.state.isLoaded) return <Loading />;

    const visibleItems = this.state.items.slice(0, this.state.visibleCount);
    const hasMore = this.state.visibleCount < this.state.items.length;

    return (
      <section className="bgg-section bgg-section-grey">
        <div className="bgg-container">
          <div className="bgg-section-header">
            <span className="bgg-section-label">Latest Updates</span>
            <div>
              <h2 className="bgg-section-title">{this.props.title || 'News & Updates'}</h2>
            </div>
          </div>

          <div className="bgg-news-grid">
            {visibleItems.map((item, key) => {
              const imageUrl = getImageUrl(item);

              return (
                <AlertDialogSlide
                  key={key}
                  title={item.titulli || ''}
                  description={item.teksti || ''}
                >
                  <div className="bgg-news-card" style={{ cursor: 'pointer' }}>
                    <div className="bgg-news-media">
                      {imageUrl && (
                        <img
                          src={normalizeImageUrl(imageUrl)}
                          alt={item.titulli}
                          className="bgg-news-img"
                          loading="lazy"
                          decoding="async"
                          referrerPolicy="no-referrer"
                          onError={(event) => {
                            event.currentTarget.style.display = 'none';
                            if (event.currentTarget.nextSibling) {
                              event.currentTarget.nextSibling.style.display = 'flex';
                            }
                          }}
                        />
                      )}
                      <div className={`bgg-news-img bgg-image-placeholder${imageUrl ? ' bgg-media-fallback' : ''}`}>
                        <i className="fas fa-leaf" />
                      </div>
                    </div>
                    <div className="bgg-news-body">
                      <div className="bgg-news-date">{item.data}</div>
                      <div className="bgg-news-title">{item.titulli}</div>
                      <p className="bgg-news-excerpt">
                        {item.teksti ? item.teksti.substring(0, 120) + '…' : ''}
                      </p>
                      <button className="bgg-link-btn">
                        Read More <span aria-hidden="true">&rarr;</span>
                      </button>
                    </div>
                  </div>
                </AlertDialogSlide>
              );
            })}
          </div>

          {this.state.items.length > 6 && (
            <div className="bgg-news-actions">
              {hasMore ? (
                <button
                  type="button"
                  className="bgg-btn bgg-btn-outline"
                  onClick={() => this.setState({ visibleCount: this.state.visibleCount + 6 })}
                >
                  View More News
                </button>
              ) : (
                <button
                  type="button"
                  className="bgg-btn bgg-btn-outline"
                  onClick={() => {
                    this.setState({ visibleCount: 6 });
                    window.setTimeout(() => {
                      const section = document.querySelector('.bgg-news-grid');
                      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 0);
                  }}
                >
                  Show Less
                </button>
              )}
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default SectionProjects;



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionProjects.jsx